"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var styleBase = {
  minWidth: 64,
  height: 24,
  background: 'transparent',
  borderColor: 'grey',
  borderWidth: 1,
  outline: 'none',
  margin: 2
};
var Button = function Button(props) {
  var onClick = props.onClick,
    children = props.children;
  return react_1.default.createElement("button", {
    onClick: onClick,
    style: styleBase
  }, children);
};
exports.Button = Button;